module.exports = __webpack_public_path__ + "img/trend-shape-steady.5b2cac13.png";